import { render } from "./BusinessDirectory.vue?vue&type=template&id=5dc5c916"
import script from "./BusinessDirectory.vue?vue&type=script&lang=js"
export * from "./BusinessDirectory.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__